export default "__VITE_ASSET__C3a83VXz__"